import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Combobox } from "react-widgets";
import _ from "lodash";
import { useHistory } from "react-router-dom";
import { searchCompany, resetCompanySearch } from "../actions/index";

export const SearchBar = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const onSearchCompany = useCallback(
    _.debounce((name) => dispatch(searchCompany(name)), 300),
    [dispatch, searchCompany]
  );
  const onResetCompanySearch = useCallback(
    () => dispatch(resetCompanySearch()),
    [dispatch, resetCompanySearch]
  );
  const companySearch = useSelector((state) => state.companies);

  const [ticker, setTicker] = useState("");
  const onInputChange = useCallback(
    (value) => {
      if (typeof value === "object") {
        setTicker(value.symbol);
      } else {
        setTicker(value);
        if (value.length > 2) {
          onSearchCompany(value);
        }
      }
    },
    [setTicker, onSearchCompany]
  );
  const onOptionClicked = useCallback(
    (value) => {
      setTicker(value.symbol);
      onResetCompanySearch();
      history.push(`/report/${value.symbol}`);
    },
    [setTicker, onResetCompanySearch, history]
  );

  const companies = companySearch.map((el) => ({
    symbol: el.symbol,
    name: `${el.name} - ${el.symbol}`,
  }));

  return (
    <Combobox
      data={companies}
      suggest
      valueField="symbol"
      textField="name"
      placeholder="Enter a ticker or search a company by name"
      value={ticker}
      onChange={onInputChange}
      onSelect={onOptionClicked}
    />
  );
};

export default SearchBar;
